import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ERROR_PARAM, ERROR_REQUEST_ID_PARAM, parseUUID} from '@npck/libs/commons';
import {OauthService} from '../../domain/oauth.service';

@Component({
    templateUrl: 'error-redirect.component.html',
    styleUrls: ['error-redirect.component.scss'],
    standalone: false
})
export class ErrorRedirectComponent {
    errorCode: any;
    requestId: string;

    constructor(
        private activatedRoute: ActivatedRoute,
        private oauthService: OauthService,
    ) {
        this.errorCode = this.activatedRoute.snapshot.queryParams[ERROR_PARAM];
        this.requestId = parseUUID(this.activatedRoute.snapshot.queryParams[ERROR_REQUEST_ID_PARAM]);
    }

    onClose(): void {
        this.oauthService.redirectWithError(this.errorCode, this.requestId);
    }
}
